export default __webpack_public_path__ + "static/media/price.61f15f31.svg";